import React, { useEffect, useState } from "react";
import useAxios from "../../utils/useAxios";
import { hideModal, showModal } from "../../utils/modalUtility";
import Pagination from "../common/pagination";
import { FaSpinner } from "react-icons/fa";
import config from "../../config";

const Products = () => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [product, setProduct] = useState([]);
  const [slugError, setSlugError] = useState("");
  const [category, setCategory] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [originalSlug, setOriginalSlug] = useState("");

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [uploadedMedia, setUploadedMedia] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [mediaType, setMediaType] = useState(""); // 'image' or 'video'
  const [media, setMedia] = useState([]);
  const [selectedPreview, setSelectedPreview] = useState(null); //  preview URL

  const BASE_URL = config?.apiBaseUrl;

  const axiosAPI = useAxios();

  const [formData, setFormData] = useState({
    product_name: "",
    description: "",
    media_type: "image",
    thumbnail_url: "",
    product_url: "",
    affiliated_url: "",
    slug: "",
    category_id: "",
    sub_category_id: "",
    video_id: "",
    is_active_or_inactive_status: "",
    mediaIds: [],
  });

  function removeFormData() {
    setFormData({
      product_name: "",
      description: "",
      media_type: "image",
      thumbnail_url: "",
      product_url: "",
      affiliated_url: "",
      slug: "",
      category_id: "",
      sub_category_id: "",
      video_id: "",
      is_active_or_inactive_status: "",

      mediaIds: [],
    });
    setSlugError("");
  }

  const closeModal = () => {
    setIsEditMode(false);
    removeFormData();
    setCurrentUserId(null);
  };

  const handleCheckboxChange = (id, file_path) => {
    // console.log("id and file path", id, file_path);

    setFormData((prevFormData) => {
      const alreadySelected = prevFormData.mediaIds.includes(id);

      let updatedMediaIds;

      // const updatedMediaIds = alreadySelected
      //   ? prevFormData.mediaIds.filter((item) => item !== id) // deselect
      //   : [...prevFormData.mediaIds, id]; // select

      if (alreadySelected) {
        // Deselect
        updatedMediaIds = prevFormData.mediaIds.filter((item) => item !== id);
      } else {
        // Select
        updatedMediaIds = [...prevFormData.mediaIds, id];
      }
      //  Check if it's the first selected item (after adding)
      let newThumbnailUrl = prevFormData.thumbnail_url;

      if (!alreadySelected && prevFormData.mediaIds.length === 0) {
        // newThumbnailUrl = "/" + file_path;
        newThumbnailUrl = file_path;
      }

      // If first item is deselected, reset thumbnail_url (optional)
      if (alreadySelected && id === prevFormData.mediaIds[0]) {
        // Optional: You can reset or set to next selected item
        newThumbnailUrl = updatedMediaIds.length > 0 ? null : "";
      }

      return {
        ...prevFormData,
        mediaIds: updatedMediaIds,
        thumbnail_url: newThumbnailUrl,
      };
    });
  };

  const selectMediaFileToSend = (
    index,
    thumbnail_url,
    media_url,
    media_type
  ) => {
    // console.log("Selected Media:");

    if (selectedItems.includes(index)) {
      setSelectedItems([]);
      setSelectedPreview(null);
    } else {
      setSelectedItems([index]);
      setSelectedPreview({
        thumbnail_url,
        media_url,
        media_type,
      });

      // console.log("Selected Preview Set:", {
      //   thumbnail_url,
      //   media_url,
      //   media_type,
      // });
    }
  };

  function openMediaLibraryModal() {
    showModal("customModal");
  }

  function handleMediaSumbit() {
    // console.log("Media Ids", formData.mediaIds);
    hideModal("customModal");
  }

  async function fetchSubCategory(id) {
    try {
      const response = await axiosAPI.get(`/api/v1/all-subcategories`);
      setSubCategory(response?.data?.subcategories);
    } catch (error) {
      console.error("Error fetching category:", error);

      setSubCategory([]);
    }
  }

  // Get All Media
  const getMedia = async () => {
    try {
      const response = await axiosAPI.get("/api/media/get-media");
      setMedia(response.data.data);

      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { id, value } = e.target;

    // if (id === "product_name") {
    //   const slug = value.toLowerCase().replace(/\s+/g, "-");
    //   setFormData((prev) => ({
    //     ...prev,
    //     product_name: value,
    //     slug,
    //   }));
    // }
    // else if (id === "category_id") {
    //   setFormData((prev) => ({
    //     ...prev,
    //     category_id: value,
    //     sub_category_id: "",
    //   }));
    //   fetchSubCategory(value);
    // }
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  function openAddProductModal() {
    showModal("newUserModal");
  }
  async function fetchProduct() {
    try {
      setLoading(true);
      const response = await axiosAPI.get(`/api/v1/get-products?page=${page}`);
      setProduct(response?.data?.products);
      setTotalPages(response?.data?.totalPages);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      // Always turn off loading, whether success or error
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchProduct();
  }, [page]);

  async function validateSlugUnique(slug) {
    try {
      // console.log("Slug is ", slug);
      const response = await axiosAPI.get(`/api/v1/check-product-slug/${slug}`);

      if (response.data.success) {
        // Slug is available
        setSlugError(""); // Clear error
        return true; // valid slug
      } else {
        // Slug already exists
        setSlugError(
          response.data.message ||
            "Slug already exists. Please choose a different one."
        );
        return false; // invalid slug
      }
    } catch (error) {
      console.error("Error checking slug:", error);
      setSlugError("Error checking slug. Please try again.");
      return false; // consider invalid on error
    }
  }

  async function fetchCategory() {
    try {
      setLoading(true);
      const response = await axiosAPI.get("/api/v1/get-categories");

      const categories = response?.data?.categories;

      const limitedData = categories?.map(({ id, cat_name }) => ({
        id,
        cat_name,
      }));

      setCategory(limitedData);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      // Always turn off loading, whether success or error
      setLoading(false);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    // if (!formData.slug) {
    //   setSlugError("Slug is required");
    //   return;
    // }

    // Only check slug uniqueness if it's new OR edited
    // if (!isEditMode || formData.slug !== originalSlug) {
    //   const isSlugValid = await validateSlugUnique(formData.slug);
    //   if (!isSlugValid) return;
    // }
    const payload = {
      product_name: formData.product_name,
      description: formData.description,
      media_type: formData.media_type,
      thumbnail_url: formData.thumbnail_url,
      product_url: formData.product_url,
      affiliated_url: formData.affiliated_url,
      sub_category_id: formData.sub_category_id || "",
      media_ids: formData.mediaIds,
      // video_id: formData.video_id || "",
      // slug: formData.slug,
      // category_id: formData.category_id,
    };

    console.log("payload", payload);

    // return;

    let response;
    try {
      if (isEditMode) {
        response = await axiosAPI.put(
          `/api/v1/update-product/${currentUserId}`,
          payload
        );

        fetchProduct();
        window.notifyMessage(
          "Success",
          "Proudct Details Updated successfully",
          "success"
        );
        hideModal("newUserModal");
        fetchProduct();
        removeFormData();
      } else {
        response = await axiosAPI.post(`/api/v1/add-product`, payload);

        fetchProduct();
        window.notifyMessage(
          "Success",
          "Product Details added successfully",
          "success"
        );
        hideModal("newUserModal");
        removeFormData();
      }

      fetchProduct();
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        window.notifyMessage(
          "Error",
          error.response.data.message, // Display specific error message from backend
          "danger"
        );
      } else {
        // Handle generic errors (e.g., network errors)
        window.notifyMessage("Error", "There was an error!", "danger");
      }
    }
  };

  const openEditModal = (productId) => {
    setIsEditMode(true);
    showModal("newUserModal");
    setCurrentUserId(productId);
    // console.log("user id", productId);
    const productToEdit = product.find((product) => product.id === productId);

    // console.log(productToEdit);
    const media_ids = productToEdit?.media_ids;

    // console.log({ media_ids });
    let mediaArray = [];

    // Convert to array of strings: ["4", "3"]
    if (media_ids) {
      mediaArray = media_ids?.split(",");
    }
    // Optional: Convert to array of numbers: [4, 3]
    const mediaIdNumbers = mediaArray?.map(Number);

    // console.log("Media ids", media_ids);
    setFormData({
      product_name: productToEdit.name,
      description: productToEdit.description,
      media_type: productToEdit.media_type,
      thumbnail_url: productToEdit.thumbnail_url,
      product_url: productToEdit.product_url,
      affiliated_url: productToEdit.affiliated_url || "",
      sub_category_id: productToEdit?.sub_category_id,
      // slug: productToEdit.slug,
      // category_id: productToEdit?.category_id,
      // video_id: productToEdit.video_id,
      mediaIds: mediaIdNumbers,
    });

    setOriginalSlug(productToEdit.slug);
  };

  const handleDelete = async (id) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      const response = await axiosAPI.delete(`/api/v1/delete-product/${id}`);
      window.notifyMessage("Success", "Deleted successfully", "success");
      fetchProduct();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger"
      );
    }
  };

  async function changeProductStatus(e, commentId) {
    const currentStatus = e.target.value;

    console.log("product  Id", commentId);
    console.log("Current Status", currentStatus);

    try {
      const isConfirmed = window.confirm(
        "Are you sure you want to change the product card status?"
      );
      if (!isConfirmed) return;

      const response = await axiosAPI.put(
        `/api/v1/change-product-status/${commentId}`,
        { status: currentStatus }
      );

      fetchProduct();
      window.notifyMessage(
        "Success",
        "Product status changed successfully",
        "success"
      );
    } catch (error) {
      console.error("Error changing product status:", error);
      window.notifyMessage(
        "Error",
        "Failed to change product status. Please try again.",
        "danger"
      );
    }
  }

  // useEffect(() => {
  //   if (formData.category_id) {
  //     fetchSubCategory(formData.category_id);
  //   }
  // }, [formData.category_id]);

  useEffect(() => {
    fetchProduct();
    fetchCategory();
    getMedia();
    fetchSubCategory();
  }, []);

  return (
    <div className="container">
      <div className="page-inner">
        <div className="d-flex justify-content-end align-items-end flex-column flex-md-row">
          <div>
            <button
              type="button"
              className="btn btn-dark btn-round mb-4"
              onClick={() => openAddProductModal()}
            >
              Add New Product
            </button>
          </div>
        </div>

        <div
          className="modal fade"
          id="newUserModal"
          tabIndex="-1"
          aria-labelledby="newUserModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="newUserModalLabel">
                  {isEditMode ? "Edit Product" : "Add Product"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  {/* Product Name */}
                  <div className="mb-3">
                    <label htmlFor="product_name" className="form-label">
                      Product Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="product_name"
                      placeholder="Enter product name"
                      value={formData.product_name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Product Description */}
                  <div className="mb-3">
                    <label htmlFor="description" className="form-label">
                      Product Description
                    </label>
                    <textarea
                      type="text"
                      className="form-control"
                      id="description"
                      rows={4}
                      placeholder="Enter product description"
                      value={formData.description}
                      onChange={handleChange}
                    />
                  </div>
                  {/* Media Type */}
                  <div className="mb-3">
                    <label htmlFor="product_url" className="form-label">
                      Product Url
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="product_url"
                      placeholder="Enter product url"
                      value={formData.product_url}
                      onChange={handleChange}
                    />
                  </div>
                  {/* Affiliated Url */}
                  <div className="mb-3">
                    <label htmlFor="affiliated_url" className="form-label">
                      Affiliated Url
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="affiliated_url"
                      placeholder="Enter affiliated url"
                      value={formData.affiliated_url}
                      onChange={handleChange}
                    />
                  </div>
                  {/* Slug */}
                  {/* <div className="mb-3">
                    <label htmlFor="slug" className="form-label">
                      Slug
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="slug"
                      placeholder="Enter slug"
                      value={formData.slug}
                      onChange={handleChange}
                      required
                    />

                    {slugError && (
                      <small className="text-danger">{slugError}</small>
                    )}
                  </div> */}

                  {/* Category Id */}
                  {/* <div className="mb-3">
                    <label htmlFor="category_id" className="form-label">
                      Category
                    </label>
                    <select
                      className="form-select"
                      id="category_id"
                      value={formData?.category_id}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Category</option>
                      {category &&
                        category?.map((category) => (
                          <option key={category.id} value={category.id}>
                            {category.cat_name}
                          </option>
                        ))}
                    </select>
                  </div> */}

                  {/* Sub Category Id */}
                  <div className="mb-3">
                    <label htmlFor="sub_category_id" className="form-label">
                      Sub Category
                    </label>
                    <select
                      className="form-select"
                      id="sub_category_id"
                      value={formData.sub_category_id}
                      onChange={handleChange}
                    >
                      <option value="">Select Sub Category</option>
                      {subCategory &&
                        subCategory?.map((subCategory) => (
                          <option key={subCategory?.id} value={subCategory?.id}>
                            {subCategory?.name}
                          </option>
                        ))}
                    </select>
                  </div>

                  {/* Media Type */}
                  <div className="mb-3">
                    <label htmlFor="media_type" className="form-label">
                      Media type
                    </label>
                    <select
                      className="form-select"
                      id="media_type"
                      value={formData?.media_type || "image"} // 👈 fallback default
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select media type</option>
                      <option value="image">Image</option>
                      {/* <option value="video">Video</option> */}
                    </select>
                  </div>
                  {/* Thumbnail Url */}
                  <div className="mb-3">
                    <label htmlFor="thumbnail_url" className="form-label">
                      Thumbnail Url
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="thumbnail_url"
                      placeholder="Enter thumbnail url"
                      value={formData.thumbnail_url}
                      onChange={handleChange}
                      required={formData.media_type === "image"}
                    />
                  </div>

                  {/* Video id */}
                  {/* {formData.media_type === "video" && (
                    <div className="mb-3">
                      <label htmlFor="video_id" className="form-label">
                        Video Id
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="video_id"
                        placeholder="Enter Video Id"
                        value={formData.video_id}
                        onChange={handleChange}
                        required={formData.media_type === "video"}
                      />
                    </div>
                  )} */}

                  <button
                    type="submit"
                    className="btn btn-primary  btn-sm"
                    disabled={loading}
                  >
                    {loading ? (
                      <FaSpinner className="spinner" spin />
                    ) : isEditMode ? (
                      "Update Products"
                    ) : (
                      "Add Products"
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="customModal"
          tabIndex="-1"
          aria-labelledby="customModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog  modal-dialog-centered modal-lg modal-dialog-scrollable">
            <div className="modal-content">
              {/* Modal Header */}
              <div className="modal-header">
                <h5 className="modal-title" id="customModalLabel">
                  {mediaType === "video" ? "Media Library" : "Media Library"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body">
                {/* Top Bar */}
                <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                  <input
                    type="text"
                    className="form-control w-50"
                    placeholder="Search media..."
                    // onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
                {/* Upload Section */}
                <div className="media-grid row">
                  {media?.map((item, index) => {
                    const isChecked = formData.mediaIds?.includes(item.id);

                    return (
                      <div className="col-md-3 mb-4" key={index}>
                        <div className="card h-100">
                          <div className="position-relative">
                            {/* Show image or video based on type */}
                            {item.media_type === "video" ? (
                              <video
                                src={`${BASE_URL}${item.file_path}`}
                                controls
                                loop
                                muted
                                className="card-img-top"
                                style={{ height: "160px", objectFit: "cover" }}
                              />
                            ) : (
                              <img
                                src={`${BASE_URL}${item?.file_path}`}
                                alt={item.media_name}
                                className="card-img-top"
                                style={{ height: "160px", objectFit: "cover" }}
                              />
                            )}

                            {/* Checkbox */}
                            <div className="position-absolute top-0 end-0 p-2">
                              <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={() =>
                                  handleCheckboxChange(item.id, item.file_path)
                                }
                              />
                            </div>
                          </div>

                          <div className="card-body p-2 text-center">
                            <small className="text-muted">
                              {item.media_name}
                            </small>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                {/* Modal Inside Contain Image and Video */}
                {/* <div className="row g-3"> */}
                <div>
                  {uploadedMedia
                    .filter((item) => item.media_type === mediaType)
                    .map((item, index) => {
                      const isSelected = selectedItems.includes(index);
                      return (
                        <div className="col-6 col-md-3" key={index}>
                          <div
                            className="border rounded p-2 text-center position-relative"
                            style={{
                              cursor: "pointer",
                              maxWidth: "180px",
                              height: "130px",
                              margin: "0 auto",
                            }}
                            onClick={() =>
                              selectMediaFileToSend(
                                index,
                                item.thumbnail_url,
                                item.media_url,
                                item.media_type
                              )
                            }
                          >
                            {/*  Fixed Selection Box */}
                            <div
                              style={{
                                position: "absolute",
                                top: "5px",
                                left: "5px",
                                width: "20px",
                                height: "20px",
                                backgroundColor: "white",
                                border: "2px solid #999",
                                borderRadius: "4px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                zIndex: 2,
                                fontSize: "14px",
                                fontWeight: "bold",
                              }}
                            >
                              {isSelected ? "" : ""}
                            </div>

                            {item.media_type === "image" ? (
                              <img
                                src={item.thumbnail_url}
                                alt={`media-${index}`}
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "contain", // contain or contain based on your need
                                  borderRadius: "4px",
                                }}
                              />
                            ) : (
                              <video
                                src={item.media_url}
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "contain",
                                  borderRadius: "4px",
                                }}
                                muted
                                loop
                                playsInline
                              />
                            )}
                          </div>
                        </div>
                      );
                    })}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="btn btn-primary"
                    // data-bs-toggle="modal"
                    // data-bs-target="#customModal"
                    onClick={handleMediaSumbit}
                    // disabled={!selectedPreview}
                  >
                    Select Media From Library
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Product Table */}
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">All Products ({product?.length})</h4>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Product Name</th>
                        <th>Description</th>
                        <th>Media Type</th>
                        <th>Thumbnail Url</th>
                        <th>Product Url</th>
                        <th>Affiliated Url</th>
                        {/* <th>Slug</th> */}
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="7" className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : product?.length === 0 ? (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No products found.
                          </td>
                        </tr>
                      ) : (
                        product &&
                        product?.map((product) => (
                          <tr key={product.id}>
                            <td>{product?.name}</td>
                            <td>{product?.description}</td>
                            <td>{product?.media_type}</td>
                            <td>
                              <a
                                href={product?.thumbnail_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                title="View Thumbnail"
                              >
                                <i className="fas fa-link"></i>
                              </a>
                            </td>
                            <td>
                              <a
                                href={product?.product_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                title="View Product Url"
                              >
                                <i className="fas fa-link"></i>
                              </a>
                            </td>
                            <td>
                              <a
                                href={product?.affiliated_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                title="View Affiliated Url"
                              >
                                <i className="fas fa-link"></i>
                              </a>
                            </td>
                            {/* <td>{product?.slug}</td> */}
                            <td>
                              <select
                                className="form-select"
                                value={product.is_active_or_inactive}
                                onChange={(e) =>
                                  changeProductStatus(e, product?.id)
                                }
                              >
                                <option value="YES">Yes</option>
                                <option value="NO">No</option>
                              </select>
                            </td>
                            <td>
                              <button
                                className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                onClick={() => openEditModal(product.id)}
                              >
                                <i className="fas fa-edit"></i>
                              </button>
                              <button
                                className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                onClick={() => handleDelete(product.id)}
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <Pagination totalPages={totalPages} setPage={setPage} page={page} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;
